/* 🤖 this file was generated by svg-to-ts */
export const matIconRedo: {
  name: 'redo';
  data: string;
} = {
  name: 'redo',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/></svg>`
};
